export const GET_SUMSUB_TOKEN_REQUEST = "GET_SUMSUB_TOKEN_REQUEST";
export const GET_SUMSUB_TOKEN_SUCCESS = "GET_SUMSUB_TOKEN_SUCCESS";
export const GET_SUMSUB_TOKEN_ERROR = "GET_SUMSUB_TOKEN_ERROR";
